import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UnsavedChangesModal from '../../../../modals/UnsavedChangesModal';
import SaveFileDialog from '../../../../modals/editFile/SaveFileDialog';
import './saveAndCancelBottomButtons.scss';

class SaveAndCancelBottomButtons extends Component {
    state = {
        displayCancelationModal: false,
        isOpenSave: false
    };

    openCancelModal = () => {
        this.setState({
            displayCancelationModal: true
        });
    };

    closeCancelModal = () => {
        this.setState({
            displayCancelationModal: false
        });
    };

    continueCancelation = () => {
        this.closeCancelModal();
        this.props.onCancel();
    };

    closeSaveDialog = () => {
        this.setState({
            isOpenSave: false
        });
    };

    render() {
        return (
            <div className="spark-panel__content save-cancel-group-content">
                <div className="col-xs save-cancel-group">
                    <button className="spark-btn spark-btn--sm spark-btn--secondary" onClick={this.props.onCancelClick}>
                        CANCEL
                    </button>
                    <button
                        className="spark-btn spark-btn--sm spark-btn--primary"
                        onClick={() => {
                            this.setState({
                                isOpenSave: true
                            });
                        }}
                        disabled={this.props.isSaveBtnDisabled}
                    >
                        SAVE FILE
                    </button>
                    {this.state.displayCancelationModal && (
                        <UnsavedChangesModal
                            level={this.props.level}
                            chain={this.props.chainId}
                            hotel={this.props.hotelId}
                            onClose={this.closeCancelModal}
                            onPrimaryClick={this.continueCancelation}
                            onSecondaryClick={this.closeCancelModal}
                            titleName={this.props.titleName}
                        />
                    )}
                    <SaveFileDialog
                        setFileData={this.props.setFileData}
                        selected={this.props.selected}
                        onAfterSave={this.props.onAfterSave}
                        code={this.props.code}
                        isOpen={this.state.isOpenSave}
                        onClose={this.closeSaveDialog}
                        list={this.props.list}
                        titleName={this.props.titleName}
                        fileToSave={this.props.fileToSave}
                        themeCategory={this.props.themeCategory}
                    />
                </div>
            </div>
        );
    }
}

SaveAndCancelBottomButtons.propTypes = {
    isSaveBtnDisabled: PropTypes.boolean,
    chainId: PropTypes.string,
    hotelId: PropTypes.string,
    level: PropTypes.string,
    fileToSave: PropTypes.object,
    themeCategory: PropTypes.string
};

export default SaveAndCancelBottomButtons;



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/saveAndCancelBottomButtons/saveAndCancelBottomButtons.js